import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { AuthContext } from '../../AuthService';
import { useQueryParams } from '../../hooks';
import { Card, CardHeader, CardBody, Table } from '../../components/Bootstrap';
import config from '../../config';
import './Health.scss';

export const Health = () => {
  const auth = React.useContext(AuthContext);

  const queryParams = useQueryParams();

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const reportData = {
        permissions: auth.getPermissions(),
        // cookies: auth.cookies.getAll(),
        accessTokenInfo: auth.getAccessTokenInfo(),
        fullUrl: window.location.href,
      };

      Sentry.withScope((scope) => {
        scope.setExtras(reportData);
        Sentry.captureException(new Error('Health check'));
      });
    }
  }, [auth]);

  const fullUrl = typeof window !== 'undefined' ? window.location.href : '';
  const isDebug = queryParams.get('debug') === 'true';

  return (
    <Card className='mt-3 mb-3 health-card'>
      <CardHeader>Health</CardHeader>
      <CardBody>
        {isDebug ? (
          <Table>
            <tbody>
              <tr>
                <td>Full URL:</td>
                <td>{fullUrl}</td>
              </tr>
              <tr>
                <td>Config:</td>
                <td>{JSON.stringify(config, null, 2)}</td>
              </tr>
              <tr>
                <td>Permissions:</td>
                <td>{auth.getPermissions()}</td>
              </tr>
              <tr>
                <td>Access Token Info:</td>
                <td>{JSON.stringify(auth.getAccessTokenInfo(), null, 2)}</td>
              </tr>
              <tr>
                <td>Cookies:</td>
                <td>
                  <div>{JSON.stringify(auth.cookies.getAll(), null, 2)}</div>
                </td>
              </tr>
            </tbody>
          </Table>
        ) : (
          <div className='mt-3 mb-3 text-center'>Thanks! A Noble team member will be in contact with you shortly.</div>
        )}
      </CardBody>
    </Card>
  );
};
